import { jsx as _jsx } from "react/jsx-runtime";
const Logout = ({ className, iconColor = 'currentColor', }) => {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", className: className, children: _jsx("path", { stroke: iconColor, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "m16 17 5-5-5-5M21 12H9M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }) }));
};
export default Logout;
//# sourceMappingURL=logout.js.map